(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.provider.phone-validate-api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../api/async')
    ])
    .provider('PhoneValidateApi', phoneValidateApiApiProvider)

  function phoneValidateApiApiProvider () {
    return {
      $get: phoneValidateApiService
    }
  }

  phoneValidateApiService.$inject = ['SdkConfig', 'ThismomentAsyncApi']
  function phoneValidateApiService (SdkConfig, ThismomentAsyncApi) {
    var API = ThismomentAsyncApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/validator/v1/is-phone-number')

    return {
      validate: validate
    }

    function validate (phoneNumber) {
      var postBody = {
        phone_number: phoneNumber
      }

      return API.post({}, postBody)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/provider/phone-validate-api.js